<template>
  <div>
     
    <v-toolbar flat color="white" class="pt-3">
      <v-spacer></v-spacer>
      <!-- <v-btn @click="test()">Test</v-btn> -->
      <v-btn round class="primary" @click="addIntegrationModal=true;dataTillAuthorized=false">Add Integration</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      class="elevation-1"
       :rows-per-page-items="[10, 25, 50, 100]"
      :items="integrations"
      :loading="isloading"
      item-key="id"
      align-center
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon small @click="editItem(props.item)">edit</v-icon>
        </td>

        <td class="text-xs-center">{{props.item.name}}</td>
        <td class="text-xs-center">{{props.item.description}}</td>
        <td class="text-xs-center">{{props.item.apiUrl}}</td>
        <td class="text-xs-center">{{props.item.token}}</td>
        <td class="text-xs-center">{{props.item.publicKey}}</td>
        <td class="text-xs-center">{{props.item.secretKey}}</td>
        <td class="text-xs-center">{{props.item.refreshToken}}</td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="addIntegrationModal" max-width="750px">
      <v-snackbar :timeout="timeout" :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD INTEGRATION</h1>
        </v-toolbar>

        <v-card flat>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12 >
                    <v-autocomplete
                      :items="availableIntegrations"
                      v-model="editedItem.name"
                      label="Choose Integration"
                    ></v-autocomplete>
                  </v-flex>
                  <v-layout v-if="editedItem.name == 'BulkSMS'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Secret Key"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout v-else-if="editedItem.name == 'LibreNMS'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name == 'Xero'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="Callback URL"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.publicKey" label="Client ID"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Secret Key"></v-text-field>
                    </v-flex>
                  </v-layout>

                   <v-layout  v-else-if="editedItem.name == 'Netcash: Debit Orders'" justify-center wrap>
                    <v-flex xs12>
                      <v-text-field v-model="editedItem.secretKey" label="Service Key"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout  v-else-if="editedItem.name == 'Netcash: Pay Now'" justify-center wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Service Key"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout  v-else-if="editedItem.name == 'SageOne Accounting'" justify-center wrap>
                     <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Service Key"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name == 'Datatill'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field prefix="https://" v-model="editedItem.apiUrl" label="*API URL"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.publicKey" label="Client ID"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Secret Key"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="*Access Token"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.refreshToken" label="Refresh Token"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name.includes('OneSignal')" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="REST API Key"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="OneSignal App ID"></v-text-field>
                    </v-flex>
                  </v-layout>
                   <v-layout v-else-if="editedItem.name.includes('Mailgun')" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Private API Key"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" class="white--text" round @click="close">Cancel</v-btn>
              <v-btn v-if="(editedItem.name == 'Datatill')&&editedItem.apiUrl&&editedItem.token&&!dataTillAuthorized" color="primary" class="white--text" round @click="testDatatill()">Test Authorization</v-btn>

              <v-btn v-if="(editedItem.name == 'Datatill')&&dataTillAuthorized" color="primary" class="white--text" round @click="addIntegration">Save</v-btn>
              <v-btn v-else-if="(editedItem.name !== 'Datatill')" color="primary" class="white--text" round @click="addIntegration">Save</v-btn>

            </v-layout>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editIntegrationModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT INTEGRATION</h1>
        </v-toolbar>

        <v-card flat>
          <v-card flat>
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap>
                  <v-flex xs12 >
                    <v-autocomplete
                      :items="availableIntegrations"
                      v-model="editedItem.name"
                      label="Choose Integration"
                    ></v-autocomplete>
                  </v-flex>
                  <v-layout v-if="editedItem.name == 'BulkSMS'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Secret Key"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name == 'LibreNMS'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name == 'Xero'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.publicKey" label="Client ID"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Secret Key"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout  v-else-if="editedItem.name == 'Netcash: Debit Orders'" justify-center wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Service Key"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout  v-else-if="editedItem.name == 'Netcash: Pay Now'" justify-center wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Service Key"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout  v-else-if="editedItem.name == 'SageOne Accounting'" justify-center wrap>
                     <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Service Key"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name == 'Datatill'" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field prefix="https://" v-model="editedItem.apiUrl" label="*API URL"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.publicKey" label="Client ID"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Secret Key"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="*Access Token"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.refreshToken" label="Refresh Token"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-else-if="editedItem.name.includes('OneSignal:testWebApp')||editedItem.name.includes('OneSignal:webApp')||editedItem.name.includes('OneSignal: Customer App')" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.token" label="REST API Key"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="OneSignal App ID"></v-text-field>
                    </v-flex>
                  </v-layout>
                     <v-layout v-else-if="editedItem.name.includes('Mailgun')" wrap>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.apiUrl" label="API Endpoint"></v-text-field>
                    </v-flex>

                    <v-flex xs12 >
                      <v-text-field v-model="editedItem.secretKey" label="Private API Key"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" class="white--text" round @click="close">Cancel</v-btn>
              <v-btn color="primary" class="white--text" round @click="save">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      timeout: 10000,
      snackbar: false,
      text: "",
      y: "top",
      dataTillAuthorized:false,
      availableIntegrations: ["BulkSMS", "Datatill", "LibreNMS", "Mailgun", "Netcash: Debit Orders", "Netcash: Pay Now", "OneSignal: Customer App", "OneSignal: Technician Mobile App", "SageOne Accounting", "Xero"],
      loading: false,
      isloading: true,
      addIntegrationModal: false,
      editIntegrationModal: false,
      integrations: [],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "API URL",
          align: "center",
          value: "apiUrl"
        },
        {
          text: "Token",
          align: "center",
          value: "token"
        },
        {
          text: "Public Key",
          align: "center",
          value: "publicKey"
        },
        {
          text: "Secret Key",
          align: "center",
          value: "secretKey"
        },
         {
          text: "Refresh Token",
          align: "center",
          value: "refreshToken"
        }
      ],
      editedItem: {
        name: "",
        description: "",
        token: "",
        publicKey: "",
        apiUrl: "",
        secretKey: "",
        apiUrl: "",
        refreshToken:"",
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        name: "",
        description: "",
        token: "",
        publicKey: "",
        secretKey: "",
        apiUrl: "",
        refreshToken:"",
        isActive: true,
        isDeleted: false
      }
    };
  },
  created() {
    this.initialize();
    console.log(this.$store.state)
  },
  methods: {
    test(){
  Api().get('/datatill/dataProducts').then(response=>{
    console.log(response.data)
  })
    },
    initialize() {
      this.getAllIntegrations();
    },
    getAllIntegrations() {
      this.isloading = true;
      Api()
        .get("/integrations/byOrg/"+ this.$store.state.currentOrg.org.id)
        .then(response => {
          this.integrations = response.data;
          this.isloading = false;
        });
    },
    getLibreDevices() {
      Api()
        .get("/allLibreDevices")
        .then(response => {});
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editIntegrationModal = true;
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.addIntegrationModal = false;
      this.editIntegrationModal = false;
      this.dataTillAuthorized=false
    },
    testDatatill(){
    if(this.editedItem.name==='Datatill'){
              Api().post('/datatill/authenticate',{
                 token: this.editedItem.token,
                 apiUrl: this.editedItem.apiUrl
                 }).then(response=>{
                  if(response.data.status==='OK'){
                    this.dataTillAuthorized=true
                    this.text = "Authorization Successful! Please save integration details.";
                    this.snackbar = true;
                  }else{
                    this.text = "Authorization Unsuccessful! Please enter a valid API URL and Access Token.";
                    this.snackbar = true;
                  }
                })
            }
    },
    addIntegration() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
      if (proceed == true) {
        Api()
          .post("/integrations", {
            name: this.editedItem.name,
            description: this.editedItem.description,
            token: this.editedItem.token,
            publicKey: this.editedItem.publicKey,
            secretKey: this.editedItem.secretKey,
            apiUrl: this.editedItem.apiUrl,
            refreshToken: this.editedItem.refreshToken,
            isActive: this.editedItem.isActive,
            isDeleted: this.editedItem.isDeleted
          })
          .then(response => {           
            this.initialize();
          });
        this.close();
      }
    },
    save() {
      let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please enter a name.");
      }
      if (proceed == true) {
        Api()
          .put("/integrations/" + this.editedItem.id, {
            name: this.editedItem.name,
            description: this.editedItem.description,
            token: this.editedItem.token,
            publicKey: this.editedItem.publicKey,
            secretKey: this.editedItem.secretKey,
            apiUrl: this.editedItem.apiUrl,
            refreshToken: this.editedItem.refreshToken,
            isActive: this.editedItem.isActive,
            isDeleted: this.editedItem.isDeleted
          })
          .then(response => {
            this.initialize();
          });
        this.close();
      }
    }
  }
};
</script>

